import React from "react";
import GATSBY_COMPILED_MDX from "/home/runner/work/WorthyD-worthyd.com/WorthyD-worthyd.com/content/blog/2010/12/manage-scripts-styles.md";
import PostTemplate from './index';
const TemplateComponent = PostTemplate;
const PostTemplateQuery = "842063436";
TemplateComponent
export default function GatsbyMDXWrapper(props) {
  return React.createElement(TemplateComponent, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export {Head} from './index';
